// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"a2f50911","217":"db2452dd","787":"d4c10e0b"}[chunkId] + ".chunk.js";
};